import React, { useEffect, useState } from "react";
import axios from "../../../../axios";
import { useParams } from "react-router-dom";
import { IP } from "../../../../internalServer";
import { RxCross2 } from "react-icons/rx";

function MemberList({ totalMember, setClickList }) {
  const hello = {
    position: "absolute",
    zIndex: 100,
    width: "150px",
  };

  return (
    <>
      <div style={hello} className=" mt-2 p-0 student_list_box ">
        <div className=" student_list_header_colour"></div>
        <div className="mx-2 mt-1 completed_student_count d-flex justify-content-between align-items-center">
          <strong>Post liked by</strong>
          <RxCross2 onClick={() => setClickList(false)} />
        </div>
        <div className="mx-2 mt-1 completed_student_count">
          Total {totalMember?.length} Users
        </div>
        <div className="p-2 mt-1 completed_name_list_box ">
          <div className="mb-2 gap-2 d-flex flex-column">
            {totalMember?.length > 0 &&
              totalMember?.map((obj, index) => (
                <div className="d-flex align-items-center">
                  {
                    obj?.userType === "Teacher" ?
                      (<img
                        src={
                          obj?.profile_picture
                            ? IP + obj?.profile_picture.replace(/^\./, "")
                            : obj?.gender === "M"
                              ? "/images/Teacher_Male.jpg"
                              : obj?.gender === "F"
                                ? "/images/Teacher_Female.png"
                                : "/images/default image.png"
                        }
                        alt="icon"
                        className=""
                        style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer", marginRight: "10px" }}
                        key={obj?.avatarProfile}
                        onError={(e) => {
                          if (obj?.gender === "M") {
                            e.target.src = "/images/Teacher_Male.jpg"
                          } else if (obj?.gender === "F") {
                            e.target.src = "/images/Teacher_Female.png"
                          } else {
                            e.target.src = "/images/default image.png"
                          }
                        }}
                      />) : obj?.userType === "Student" ? (<img
                        src={
                          obj?.profile_picture
                            ? IP + obj?.profile_picture.replace(/^\./, "")
                            : obj?.gender === "M"
                              ? obj?.avatarProfile ? '/images/Boys/' + obj?.avatarProfile + '.webp'
                                : "/images/Student_boy_pic.png"
                              : obj?.gender === "F"
                                ? obj?.avatarProfile ? '/images/Girls/' + obj?.avatarProfile + '.webp'
                                  : "/images/Student_girl_pic.png"
                                : "/images/default image.png"
                        }
                        alt="icon"
                        className=""
                        style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer", marginRight: "10px" }}
                        key={obj?.avatarProfile}
                        onError={(e) => {
                          if (obj?.gender === "M") {
                            e.target.src = obj?.avatarProfile ? '/images/Boys/' + obj?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                          } else if (obj?.gender === "F") {
                            e.target.src = obj?.avatarProfile ? '/images/Girls/' + obj?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                          } else {
                            e.target.src = "/images/default image.png"
                          }
                        }}
                      />) : <img src="/images/default image.png" alt="" style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer", marginRight: "10px" }} />
                  }
                  <span key={index} className=" completed_s_name_list">
                    {obj?.name}
                  </span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default MemberList;
